import { createFileRoute, redirect } from '@tanstack/react-router';
import { NO_ACCESS_PATH, landingPath } from '../../shell/nav.ts';
import { NoAccessPage } from '../../shell/section-placeholder.tsx';

// Only for a person whose role opens no section; anyone else typing the URL goes to their page.
export const Route = createFileRoute('/_authed/no-access')({
  beforeLoad: ({ context }) => {
    const landing = landingPath(context.me);
    if (landing !== NO_ACCESS_PATH) throw redirect({ to: landing, replace: true });
  },
  component: NoAccessPage,
});
